export const gemuesegyrosVegan  = {
	name: 'Gemüsegyros vegan mit frischem knackigem Gemüse',
	desc: 'Sojasahnesauce, Djuvecreis, Mais-Krautsalat und dazu Tagesdessert Apfel',
	image: 13,
	benefits: [
		'Vegan',
		'Viele Vitamine',
		'Viel Magnesium',
	],
	opinions: [
		{
			name: 'Mareike Mann',
			date: '17. März 2017',
			title: 'Sehr lecker',
			content: 'Hat mir wie immer gut geschmeckt. Lieber Gruß an die Leute die da kochen ;)',
			rating: 5,
		},
	],
	warnings: ['soja'],
	ingredients: [
		'Kartoffeln',
		'Paprika',
		'Zucchini',
		'Champignons',
		'Zwiebeln',
		'Knoblauch',
		'Tomatenmark',
		'Olivenöl',
		'Salz',
		'Pfeffer',
		'Thymian',
		'Rosmarin',
		{'Zucker': 'zucker'},
		'Zitronenschale',
	],
};



// WEBPACK FOOTER //
// ./src/dishes/single-dishes/gemuesegyrosVegan.js